import React, { FC, ReactNode } from "react";

import { faCircleQuestion } from "@fortawesome/pro-duotone-svg-icons/faCircleQuestion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popover from "antd/es/popover";

import styles from "./StyleSection.module.scss";

export interface StyleSectionProps {
  action?: ReactNode;
  children: ReactNode;
  info?: ReactNode;
  title: ReactNode;
}

const StyleSection: FC<StyleSectionProps> = ({ action, children, info, title }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>
          <div className={styles.titleText}>{title}</div>
          {info && (
            <Popover content={info} destroyTooltipOnHide showArrow={false}>
              <FontAwesomeIcon className={styles.icon} icon={faCircleQuestion} />
            </Popover>
          )}
        </div>
        {action && <div className={styles.action}>{action}</div>}
      </div>
      {children}
    </div>
  );
};

export default StyleSection;
